export * from './besichtigung-geordnet.interface';
